/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpResponse} from '@angular/common/http';

import {Observable} from 'rxjs/Observable';

import {ExcelExportFilterParamsWrapper} from '../model/excelExportFilterParamsWrapper';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class DocumentControllerService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost:8084';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Export a document with the historical values returned by the selected filters
   * Export a document with the historical values returned by the selected filters
   * @param excelExportFilterParamsWrapper excelExportFilterParamsWrapper
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTranchesToExcelDocumentUsingPOST(excelExportFilterParamsWrapper: ExcelExportFilterParamsWrapper, observe?: 'body', reportProgress?: boolean): Observable<string>;

  public exportTranchesToExcelDocumentUsingPOST(excelExportFilterParamsWrapper: ExcelExportFilterParamsWrapper, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;

  public exportTranchesToExcelDocumentUsingPOST(excelExportFilterParamsWrapper: ExcelExportFilterParamsWrapper, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;

  public exportTranchesToExcelDocumentUsingPOST(excelExportFilterParamsWrapper: ExcelExportFilterParamsWrapper, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (excelExportFilterParamsWrapper === null || excelExportFilterParamsWrapper === undefined) {
      throw new Error('Required parameter excelExportFilterParamsWrapper was null or undefined when calling exportTranchesToExcelDocumentUsingPOST.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/octet-stream'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/json'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post(`${this.basePath}/doc-api/historical-values/export`,
      excelExportFilterParamsWrapper,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
        responseType: 'blob'
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
